export default __webpack_public_path__ + "static/media/fixedDeposit.f99ff68b.svg";